/**
 * Return the browser's IANA timezone identifier (e.g. "Australia/Sydney",
 * "Pacific/Auckland", "America/New_York"). Used as the value of the
 * X-Client-Timezone header on requests to LLM-backed endpoints so the
 * backend can inject the correct local date into the model's system message.
 *
 * Returns undefined if the runtime doesn't support resolving timezones —
 * the backend then falls back to UTC, which is safer than a hardcoded zone.
 */
export function getClientTimeZone(): string | undefined {
  try {
    const zone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return zone && zone !== "UTC" ? zone : undefined;
  } catch {
    return undefined;
  }
}

/**
 * Build a fetch headers object including X-Client-Timezone when available.
 * Spread the result into your existing headers:
 *
 *   headers: { ...timezoneHeaders(), Authorization: `Bearer ${token}`, ... }
 */
export function timezoneHeaders(): Record<string, string> {
  const tz = getClientTimeZone();
  return tz ? { "X-Client-Timezone": tz } : {};
}
